<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="center"
  [closable]="false" [(visible)]="showDialog"
>
  <ng-template pTemplate="header">
    {{ 'banner-ads.embed-code-dialog.title' | translate | titlecase }}
  </ng-template>
  <div class="mv-10 mb-20">
    {{ 'banner-ads.embed-code-dialog.instructions' | translate }}
  </div>
  <div class="mct-grid mct-cols-1-1 mct-gap-54"  >
    <div class="mv-10">
      <label>{{ 'banner-ads.embed-code-dialog.banner-name' | translate }}</label>
      <p-select
        name="formType"
        [options]="bannerNames"
        [style]="{ width: '100%' }"
        [(ngModel)]="bannerNameSelected"
        appendTo="body"
      ></p-select>
    </div>
    <div class="mv-10">
      <label>{{ 'banner-ads.embed-code-dialog.keywords' | translate }}</label>
      <input name="keywords" type="text" class="form-control" style="width: 100%" [(ngModel)]="keywords" />
    </div>
  </div>
  <div class="mv-10 t-ac">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="generateEmbedCode()">
      {{ 'banner-ads.embed-code-dialog.button-generate-embed-code' | translate | uppercase }}
    </button>
  </div>
  <div class="mv-20 t-ac">
    <label>{{ 'banner-ads.embed-code-dialog.embed-code-generated' | translate }}</label>
    <textarea pInputTextarea name="embed-code-generated" [autoResize]="true" [(ngModel)]="embedCodeGenerated" rows="5" style="width: 100%" readonly></textarea>
    <div class="mv-10">
      <wl-ephemeral-content-swap #contentSwap>
        <button pButton type="button" class="atlas-btn atlas-btn-primary" ngxClipboard [cbContent]="embedCodeGenerated" (click)="contentSwap.show()">
          {{ 'banner-ads.embed-code-dialog.button-copy-embed-code' | translate | uppercase }}
        </button>
        <div class="wl-ephemeral-content">
          {{ 'common.copied-to-clipboard' | translate | ucfirst }}
        </div>
      </wl-ephemeral-content-swap>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      {{ 'common.close' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
